import adminApi from './api';
import { adminLogout, forceAdminLogout } from '../../utils/admin/logout'

const authService = {
  // Login admin user
  login: async (email, password) => {
    try {
      const response = await adminApi.post('/auth/login', {
        email,
        password,
      });
      
      const { data } = response.data;
      
      if (data.token) {
        // Store token in localStorage
        localStorage.setItem('admin_token', data.token);
        
        // Store user data (excluding sensitive info)
        const userData = {
          user: data.user,
          admin: data.admin,
          permissions: data.admin.permissions,
        };
        localStorage.setItem('admin_user', JSON.stringify(userData));
      }
      
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Logout admin user
  logout: (options = {}) => {
    return adminLogout(options);
  },

  // Request password reset (send verification code)
  requestPasswordReset: async (email) => {
    try {
      const response = await adminApi.post('/password/request-reset', {
        email,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Verify reset code and set new password
  resetPassword: async (userId, code, newPassword, confirmPassword) => {
    try {
      const response = await adminApi.post('/password/verify-reset', {
        userId,
        code,
        newPassword,
        confirmPassword,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Resend verification code
  resendVerificationCode: async (userId) => {
    try {
      const response = await adminApi.post('/password/resend-code', {
        userId,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Verify reset code only (without password reset)
  verifyResetCode: async (userId, code) => {
    try {
      const response = await adminApi.post('/password/validate-code', {
        userId,
        code,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Force logout (for interceptors, token expiration)
  forceLogout: () => {
    return forceAdminLogout();
  },

  // Get current user from storage
  getCurrentUser: () => {
    try {
      const userStr = localStorage.getItem('admin_user');
      return userStr ? JSON.parse(userStr) : null;
    } catch (error) {
      return null;
    }
  },

  // Get auth token
  getToken: () => {
    return localStorage.getItem('admin_token');
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    const token = localStorage.getItem('admin_token');
    const user = authService.getCurrentUser();
    return !!(token && user);
  },

  // Check if user has specific permission
  hasPermission: (permission) => {
    const user = authService.getCurrentUser();
    if (!user || !user.permissions) return false;
    return user.permissions.includes(permission);
  },

  // Check if user has any of the given permissions
  hasAnyPermission: (permissions) => {
    const user = authService.getCurrentUser();
    if (!user || !user.permissions) return false;
    return permissions.some(permission => user.permissions.includes(permission));
  },

  // Check if user has all given permissions
  hasAllPermissions: (permissions) => {
    const user = authService.getCurrentUser();
    if (!user || !user.permissions) return false;
    return permissions.every(permission => user.permissions.includes(permission));
  },
};

export default authService;